import React from 'react';
import { WizardItem } from '../../../Interfaces/Wizard.interface';
import { WizardItemType } from '../../../Enums/WizardItemType.enum';
import CodeField from '../../../../BaseModule/Components/Form/Components/CodeField/CodeField';

interface Props {
	item: Extract<WizardItem, { type: WizardItemType.CODE_INPUT }>;
}

const WizardCodeInput: React.FC<Props> = ({ item }) => {
	return (
		<CodeField
			name={item.key}
			length={item.settings.length}
			isRequired={item.settings?.required}
			type={item.settings.keyboardType}
		/>
	);
};

export default WizardCodeInput;
